/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  API_CUSTOM_CODE,
  clearLS,
  formatMoney,
  handleRetrieveCartOrders,
  handleRetrieveUser,
  verifyPaymentError,
} from "../utils/functions";
import { StatusRenderer } from "./error-screen";

// const PAYMENT_STATUS_PENDING = "pending";
const PAYMENT_STATUS_FAILED = "failed";
const PAYMENT_STATUS_SUCCESS = "completed";

export function ConfirmPayment() {
  const {
    state: {
      ngPayment,
      amount,
      reference: orderReference,
      hasOrderReference = false,
      hasActiveLoanContract,
    },
  } = useLocation();
  const qParameters = new URLSearchParams(window.location.search);
  const reference = qParameters.get("payment_intent");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = useState("");
  const user = handleRetrieveUser();
  const cart = handleRetrieveCartOrders();
  const [orderId, setOrderId] = useState("");
  const [error, setError] = useState({ message: "", title: "" });

  const verifyPaymentTransaction = useCallback(async () => {
    try {
      const {
        data: {
          data: {
            paymentAuth,
            paymentTransaction,
            customCode,
            status: customStatus,
          },
        },
      } = await axios.get(
        `${process.env.REACT_APP_VERIFY_PAYMENT}/${reference}`,
        {
          headers: { "x-api-key": user.apiKey },
        },
      );
      setPaymentStatus(paymentAuth?.status);
      if (paymentTransaction?.reference) {
        setOrderId(paymentTransaction?.reference);
        setPaymentStatus(PAYMENT_STATUS_SUCCESS);
      }
      if (customStatus && customStatus === PAYMENT_STATUS_FAILED) {
        // yet to be tested
        if (customCode && customCode === API_CUSTOM_CODE) {
          setError(verifyPaymentError(customCode));
          const rerouteTimeout = setTimeout(
            () => navigate(`/wholesale/checkout?token=${cart.authToken}`),
            3000,
          );
          return () => clearTimeout(rerouteTimeout);
        }
      }
      if (paymentAuth?.status === PAYMENT_STATUS_FAILED) {
        setError(verifyPaymentError(paymentAuth?.code));
      }
    } catch (err) {
      setPaymentStatus("pending");
    }
  }, []);

  const handleConfirmNGPayment = () => {
    setLoading(false);
    setPaymentStatus(PAYMENT_STATUS_SUCCESS);
    clearLS();
  };

  useEffect(() => {
    if (ngPayment || hasOrderReference) {
      return handleConfirmNGPayment();
    }
    verifyPaymentTransaction();
    if (paymentStatus === PAYMENT_STATUS_SUCCESS) {
      const leaveUser = true;
      clearLS(leaveUser);
    }
    let intervalId;
    intervalId = setInterval(() => {
      if (
        paymentStatus === PAYMENT_STATUS_FAILED ||
        paymentStatus === PAYMENT_STATUS_SUCCESS
      ) {
        setLoading(false);
        return () => clearInterval(intervalId);
      } else {
        verifyPaymentTransaction();
      }
    }, 5000); // Interval set to 5 seconds (5000 milliseconds)
    return () => clearInterval(intervalId);
  }, [paymentStatus]);

  return loading ? (
    <div className='trade-uk-payment_verify-view'>
      <img src='../images/loading-circle.gif' alt='loading-gif' />
      <p>We are verifying your payment...</p>
    </div>
  ) : paymentStatus === PAYMENT_STATUS_SUCCESS ? (
    <div className='trade-uk-order-success'>
      <div>
        <center>
          <div className='trade-uk-order-success_box-bg'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='48'
              height='48'
              viewBox='0 0 48 48'
              fill='none'
            >
              <path
                d='M43.8716 14.8212C43.8716 14.8075 43.867 14.7983 43.867 14.7845C43.867 14.4267 43.4771 14.2248 43.1743 14.39C42.5182 14.7386 41.8621 15.0919 41.2061 15.4406C39.6462 16.2756 38.0817 17.1106 36.5218 17.9456C34.627 18.9595 32.7322 19.9688 30.842 20.9828C29.2041 21.859 27.5663 22.7353 25.9284 23.607C25.1989 23.997 24.4465 24.3594 23.7308 24.7724C23.1573 24.465 22.5792 24.1576 22.0012 23.8502C20.4413 23.0152 18.8768 22.1802 17.3169 21.3452C15.4221 20.3313 13.5273 19.3219 11.6371 18.308C9.99923 17.4317 8.36136 16.5554 6.72348 15.6837C5.92977 15.2571 5.14066 14.812 4.33777 14.4083C4.3286 14.4037 4.30566 14.3945 4.29648 14.39C3.99368 14.2294 3.59912 14.4267 3.59912 14.7845V32.5809C3.59912 33.3976 3.57618 34.2234 3.6083 35.0446C3.6083 35.0584 3.61289 35.0676 3.61289 35.0813C3.61289 35.2373 3.70006 35.4025 3.84228 35.4759C4.49376 35.8246 5.14983 36.1733 5.8059 36.5219C7.37496 37.3615 8.94402 38.1965 10.5131 39.0361L16.1837 42.0641C17.817 42.9358 19.4549 43.8075 21.0882 44.6838C21.8865 45.1105 22.6756 45.5555 23.4785 45.9592C23.4922 45.9638 23.5014 45.973 23.5106 45.9776C23.6023 46.0281 23.6895 46.0418 23.7721 46.0326H23.7813C23.8455 46.0281 23.9143 46.0097 23.9739 45.9776C24.6254 45.6289 25.2815 45.2802 25.933 44.9315C27.502 44.092 29.0711 43.257 30.6402 42.4174L36.3108 39.3894C37.9441 38.5177 39.5774 37.646 41.2107 36.7697C42.0044 36.343 42.8302 35.953 43.6055 35.4943C43.6147 35.4897 43.6376 35.4805 43.6468 35.4759C43.8212 35.3841 43.8808 35.2327 43.8808 35.0813V17.2803C43.8808 16.4683 43.9037 15.6425 43.8716 14.8212Z'
                fill='#FF8D06'
              />
              <path
                d='M32.5258 5.79257C32.3698 5.88433 32.2093 5.9715 32.0533 6.06325C31.9248 6.13666 31.8009 6.20548 31.6725 6.27889C31.6404 6.29724 31.6082 6.31559 31.5807 6.33394C29.9428 7.26528 28.305 8.19204 26.6671 9.12338C24.6484 10.2704 22.6297 11.4127 20.6111 12.5597C18.8631 13.5507 17.1197 14.5417 15.3763 15.5327C14.9083 15.7988 14.4404 16.0557 13.9678 16.3172C13.8072 16.4044 13.6512 16.4961 13.4952 16.5833C13.3393 16.675 13.1833 16.7622 13.0273 16.854C12.2932 16.464 11.5546 16.074 10.8205 15.6886C9.27898 14.8766 7.74203 14.0599 6.2005 13.2479L4.27359 12.2294C3.97537 12.0734 3.97537 11.5963 4.27359 11.4357C4.31488 11.4127 4.35617 11.3898 4.40205 11.3669C5.31045 10.8851 6.21885 10.408 7.12725 9.92626C8.80183 9.0408 10.481 8.15533 12.1556 7.26987C13.9999 6.29724 15.8397 5.3246 17.684 4.34738C19.1384 3.58121 20.5927 2.81503 22.0425 2.04885C22.437 1.84239 22.8316 1.63135 23.2262 1.4249C23.4785 1.29185 23.6941 1.14045 23.9969 1.28726C24.7677 1.66805 25.5201 2.09014 26.2817 2.49388C27.8829 3.33805 29.4795 4.18222 31.0806 5.03098C31.5624 5.28331 32.0441 5.53565 32.5258 5.79257ZM43.4312 11.8302C43.445 11.9816 43.3808 12.1284 43.2018 12.2248C43.1605 12.2477 43.1193 12.2707 43.0734 12.2936C42.165 12.7753 41.2566 13.2571 40.3482 13.7342C38.6736 14.6197 36.9944 15.5051 35.3198 16.3906C33.4755 17.3632 31.6358 18.3405 29.7914 19.3131C28.3417 20.0793 26.8873 20.8454 25.4375 21.6162C25.043 21.8227 24.6484 22.0337 24.2538 22.2402C24.0015 22.3732 23.7859 22.5246 23.4831 22.3778C22.7123 21.997 21.9599 21.5703 21.1983 21.1712C19.5971 20.327 18.0006 19.4782 16.3994 18.6341C15.9222 18.3817 15.4405 18.1294 14.9634 17.8725C15.1194 17.7807 15.2799 17.6936 15.4359 17.6018C15.5598 17.533 15.6837 17.4596 15.8075 17.3908C15.8397 17.3724 15.8764 17.3541 15.9085 17.3311C17.5418 16.4044 19.1796 15.473 20.8129 14.5463C22.8316 13.3993 24.8503 12.2569 26.8689 11.1099C28.6169 10.1189 30.3603 9.12797 32.1037 8.13698C32.5717 7.87088 33.0442 7.60937 33.5168 7.34786C33.6774 7.26069 33.8334 7.16894 33.9894 7.07718C34.1453 6.98542 34.3013 6.89825 34.4573 6.80649C35.1914 7.19646 35.9254 7.58185 36.6595 7.96723C38.201 8.77929 39.738 9.59593 41.2795 10.408L43.2064 11.4265C43.3808 11.5274 43.445 11.6788 43.4312 11.8302Z'
                fill='#FF8D06'
              />
            </svg>
          </div>
        </center>

        {ngPayment ? (
          <>
            <h3>Thank you!</h3>
            <p>
              Your wallet has been funded with{" "}
              <span>₦{formatMoney(amount)}</span>. <br />
              This will be used to pay for your order.
            </p>
            <div className='_download-container'>
              <p className=''>
                To receive notifications and order updates, download our App
              </p>
              <div className='app-buttons'>
                <a
                  href='https://play.google.com/store/apps/details?id=co.tradedepot.shop'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src='../images/google-button-2.svg' alt='' />
                </a>

                <a
                  href='https://apps.apple.com/us/app/tradedepot-wholesale/id1476690458'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src='../images/ios-button-2.svg' alt='' />
                </a>
              </div>
            </div>
          </>
        ) : (
          <>
            <h3>Thank you for your order</h3>
            <p>
              Your order reference is <span>{orderId || orderReference}</span>.{" "}
              <br />
              We will notify you when your order has been shipped.
            </p>
            <div className='_download-container'>
              <p className=''>
                To receive notifications and order updates, download our App
              </p>
              <div className='app-buttons'>
                <a
                  href='https://play.google.com/store/apps/details?id=co.tradedepot.shop.td'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src='../images/google-button-2.svg' alt='' />
                </a>

                <a
                  href='https://apps.apple.com/us/app/tradedepot-wholesale/id1476690458'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src='../images/ios-button-2.svg' alt='' />
                </a>
              </div>
            </div>
            {!hasActiveLoanContract && (
              <a
                href={`${process.env.REACT_APP_MOBILE_APP_LINK}`}
                target='_blank'
                rel='noreferrer'
              >
                <img
                  src='../images/credit-banner.png'
                  alt=''
                  className='credit-banner'
                />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  ) : paymentStatus === PAYMENT_STATUS_FAILED ? (
    <StatusRenderer title={error.title} message={error.message} />
  ) : (
    <></>
  );
}
